import $ from 'jquery'

import { registerComponent, compile } from '../app'
import { tns } from 'tiny-slider/src/tiny-slider'
import { VARIANT_CHANGE } from '../events'

const PdpCarousel = (scope, el) => {
	const state = {
		slider: null,
		activeIndex: 0
	}

	const props = {
		singleSlideClass: 'single-slide',
		activeClass: 'active'
	}

	const els = {
		container: el.querySelector('[data-items]'),
		nav: el.querySelector('[data-nav]'),
		next: el.querySelector('[data-controls="next"]'),
		prev: el.querySelector('[data-controls="prev"]'),
		$slides: [],
		$navButtons: []
	}

	function initialize() {
		setSlides()
		setNav()
		bindTouch()
		goToSlide(0)
	}

	function setSlides() {
		els.$slides = $($(els.container).children())

		if (!els.$slides.length) return

		els.$slides.length > 1
			? el.classList.remove(props.singleSlideClass)
			: el.classList.add(props.singleSlideClass)
	}

	function setNav() {
		els.nav.innerHTML = ''
		for (let i = 0; i < els.$slides.length; i++) {
			let $button = $(
				'<button data-index="' +
					i +
					'" aria-label="Carousel Slide ' +
					(i + 1) +
					'"></button>'
			)
			els.nav.appendChild($button[0])
			$button.click(e => goToSlide(e.target.getAttribute('data-index')))
		}
		els.$navButtons = $($(els.nav).children())
	}

	function bindButtons() {
		els.next && els.next.addEventListener('click', e => nextSlide())
		els.prev && els.prev.addEventListener('click', e => prevSlide())
	}

	function reinitialize(images) {
		el.style.opacity = '0'
		el.style.height = el.offsetHeight + 'px'
		el.style.overflow = 'hidden'
		setTimeout(() => {
			el.style.visibility = 'none'
			setTimeout(() => {
				els.container.innerHTML = imageHtml(images)
				initialize()
				setTimeout(() => compile(els.container), 250)
				window.requestAnimationFrame(() => {
					el.setAttribute('style', '')
				})
			}, 250)
		}, 250)
	}

	function nextSlide() {
		state.activeIndex + 1 >= els.$slides.length
			? goToSlide(0)
			: goToSlide(state.activeIndex + 1)
	}

	function prevSlide() {
		state.activeIndex - 1 < 0
			? goToSlide(els.$slides.length - 1)
			: goToSlide(state.activeIndex - 1)
	}

	function goToSlide(index) {
		els.$slides.removeClass(props.activeClass)
		els.$slides[index].classList.add(props.activeClass)
		els.$navButtons.removeClass(props.activeClass)
		els.$navButtons[index].classList.add(props.activeClass)
		state.activeIndex = index
	}

	function imageHtml(images) {
		let html = ''
		images.map(url => {
			html += `
				<div class="carousel__item">
                    <div class="carousel__item__outer">
                        <div class="carousel__item__inner">
                            <div class="contain-image">
                                <img src="${url}" data-component-load-image />
                                <div class="loader loader--dark"></div>
                            </div>
                        </div>
                    </div>
                </div>
			`
		})
		return html
	}

	function bindTouch() {
		var touchsurface = els.container,
			startX,
			startY,
			dist,
			threshold = 50, //required min distance traveled to be considered swipe
			allowedTime = 200, // maximum time allowed to travel that distance
			elapsedTime,
			startTime

		touchsurface.addEventListener(
			'touchstart',
			function(e) {
				var touchobj = e.changedTouches[0]
				dist = 0
				startX = touchobj.pageX
				startY = touchobj.pageY
				startTime = new Date().getTime() // record time when finger first makes contact with surface
			},
			false
		)

		var _this = this

		touchsurface.addEventListener(
			'touchend',
			function(e) {
				var touchobj = e.changedTouches[0]
				dist = touchobj.pageX - startX // get total dist traveled by finger while in contact with surface
				elapsedTime = new Date().getTime() - startTime // get time elapsed
				// check that elapsed time is within specified, horizontal dist traveled >= threshold, and vertical dist traveled <= 100
				var swiperightBol =
					elapsedTime <= allowedTime &&
					dist >= threshold &&
					Math.abs(touchobj.pageY - startY) <= 100
				var swipeleftBol =
					elapsedTime <= allowedTime &&
					dist <= threshold * -1 &&
					Math.abs(touchobj.pageY - startY) <= 100

				if (swiperightBol) {
					prevSlide()
					e.preventDefault()
				} else if (swipeleftBol) {
					nextSlide()
					e.preventDefault()
				}
			},
			false
		)
	}

	scope.on(VARIANT_CHANGE, variant => {
		reinitialize(variant.images)
	})

	initialize()
	bindButtons()
}

registerComponent('pdp-carousel', PdpCarousel)
